import type { GetBillingAccountOverviewResponse } from "@nlc/shared-types";

import { Link } from "@tanstack/react-router";

import { dateFormatter } from "@/utils/dateFormatter";

const EMPTY_VALUE = "-";

interface AccountDetailsCardProps {
  readonly account: GetBillingAccountOverviewResponse["account"];
}

export function AccountDetailsCard({ account }: AccountDetailsCardProps) {
  return (
    <div className="flex flex-col gap-lg rounded-xl border border-border-secondary bg-bg-primary px-3xl py-xl">
      <h3 className="text-xl font-semibold text-text-primary">
        Account details
      </h3>

      <dl className="grid grid-cols-2 gap-x-xl gap-y-lg">
        <AccountDetail label="Account ID">
          <Link
            className="underline hover:text-text-brand-secondary"
            params={{ projectId: String(account.id) }}
            to="/projects/$projectId"
          >
            {account.id}
          </Link>
        </AccountDetail>
        <AccountDetail label="Created date">
          {dateFormatter(account.createdAt)}
        </AccountDetail>
        <AccountDetail label="Responsible">
          {account.responsible?.name ?? EMPTY_VALUE}
        </AccountDetail>
        <AccountDetail label="Cancel date">
          {account.cancelledAt
            ? dateFormatter(account.cancelledAt)
            : EMPTY_VALUE}
        </AccountDetail>
      </dl>
    </div>
  );
}

function AccountDetail({
  children,
  label,
}: {
  children: React.ReactNode;
  label: string;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-xs">
      <dt className="text-xs text-text-tertiary">{label}</dt>
      <dd className="truncate text-md font-medium text-text-primary">
        {children}
      </dd>
    </div>
  );
}
